import * as ActionTypes from "../ActionTypes";

const initialState = {
  statesList:[],
  mbiDetails:{},
  ltcList:[],
  sepReasonforS:[],
  deeplinkflag:false,
    emailAddress: "",
    guestLogin: false,
    beneficiaryLogin:false,
    selectedPlan: "",
    firstName: "",
  lastName: "",
  agentLoggedIn: false,
  token: "",
  successfulSignUp: "",
  agencyID:[{label:"---Select---",value:""}],
  agencyIDSelected:"",
  agentId:"",
  selectedPlanName: "",
  selectedPlanId: "",
  selectedProductName: "",
  premiumAmount: "",
  productId:"",
  deeplink:false,
  dpzipCode:"",
  idleTime:0,
  customerId:"",
  pcpApiKey:"",
  theme:"",
  subDomain:"",
  isEligible: "",
  isResetPwd:false,
  pcpSubscription:"",
  isActive:true,
  temporaryKeyCloaktoken:"",
  isAuthorized:true,
  agentTaxId:"",
  supportingServices:[],
}
export default function LoginReducer(state = initialState, action) {
  // 23 cases
    switch (action.type) {
        case ActionTypes.SET_EMAil: {
            return {
              ...state,
              emailAddress: action.payload,
            };
          }
          case ActionTypes.LOGIN:{
      return {
        ...state,
        guestLogin: false,
        selectedPlan: "",
        firstName: action.payload.data.firstName,
        lastName: action.payload.data.lastName,
        agentFullName:action.payload.data && action.payload.data.agentDetails?.agentName,
        agentPhone:action.payload.data.agentDetails?.agentPhone??"",
        agentId:
          action.payload.data && action.payload.data.agentDetails
            ? action.payload.data.agentDetails.agentId
            : state.agentId
            ? state.agentId
            : action.agentId,
        idleTime:action.payload?.data?.tokenExpiry,
        userId:action.payload.data.userId??"",
        agentTaxId:action.payload.data.agentDetails?.agentTaxId??""
      }}
      case ActionTypes.AGENT_LOGIN: {
        return {
          ...state,
          agentLoggedIn: action.payload,
          agentId: action.agentId,
          // idleTime:action.payload?.data?.tokenExpiry
        };
      }
      case ActionTypes.TOKEN_TO_REDUX: {
        return {
          ...state,
          token: action.payload,
        };
      }
      case ActionTypes.REMOVETOKEN: {
        return {
          ...state,
          token: "",
        };
      }
      case ActionTypes.GET_AGENCYID:{
        return{
          ...state,
          agencyID:action.payload.data,
        }
      }
      case ActionTypes.SET_LOGIN_DATA: {
        return {
          ...state,
          authenticatedData: action.payload,
        };
      }
      case ActionTypes.SUCCESSFUL_SIGNUP:
      return {
        ...state,
        successfulSignUp: action.payload,
      };
      case ActionTypes.PENDING_APP_LIST:{
        return{
          ...state,
          pendingAppList:action.payload.data
        }
      }
      case ActionTypes.GUEST_LOGIN:
      return {
        ...state,
        guestLogin: true,
        selectedPlan: "",
        idleTime:action.payload.data.tokenExpiry,
        userId:action.payload.data.userId??"",
        token:action.payload.data.token??""
      };
      case ActionTypes.AGENTEMAILID: {
        return {
          ...state,
          agentEmailId: action.payload,
        };
      }
      case ActionTypes.REMOVEPLAN: {
        return {
          ...state,
          selectedPlan: "",
        };
      }
      case ActionTypes.SET_FORM_DATA: {
        return {
          ...state,
          selectedPlan: action.payload.planId,
          selectedPlanName: action.payload.planName,
          selectedPlanId: action.payload.plan,
          selectedProductName: action.payload.productName,
          premiumAmount: action.payload.premiumAmount,
          productId:action.payload.productId,
          productCategory:action.payload?.productCategory,
        };
      }
      case ActionTypes.SET_CATEGORY_NAME: {
        return {
          ...state,
          productCategory:action.payload?.productCategory,
          selectedPlanName:action.payload?.selectedPlanName,
        };
      }
      case ActionTypes.DEEPLINK: {
        return {
          ...state,
          deeplink: action.payload.deeplink,
          dpcountyName: action.payload.countyName,
          dpzipCode: action.payload.zipcode,
          dpProductId:action.payload.productId,
          dpStateCd:action.payload.stateCd,
          dpemail:action.payload.email
        };
      }
      case ActionTypes.SET_LOGIN_STATE_PARAMS: {
        return {
          ...state,
          [action.payload.type]: action.payload.data,
        };
      }
      case ActionTypes.GET_STATES:{
        return{
          ...state,
          statesList:[...[{ label: "---Select---", value: "" }],...action.payload.data]
        }
      }
      case ActionTypes.GET_CITY_LIST:{
        return{
          ...state,
          cityList:action.payload.data
        }
      }
      case ActionTypes.GET_CUSTOMER_SUBDOMAIN:{
        return{
          ...state,
          customerSubdomainDetails:action.payload.data,
          customerId:action.payload.data.customerId,
          pcpApiKey:action.payload.data.pcpApiKey,
          theme:action.payload.data.theme?action.payload.data.theme:"Default",
          subDomain:action.payload.data.subDomain?"https://"+action.payload.data.subDomain:"",
          pcpSubscription:action.payload.data.pcpSubscription,
          supportingServices:action.payload.data.supportingServices??[],
        }
      }
      case ActionTypes.GET_LTC_LIST:{
        return{
          ...state,
          ltcList:[...[{ label: "---Select---", value: "" }],...action.payload.data],
        }
      }
      case ActionTypes.PCP_MAP_SEARCH:{
        return {
          ...state
        }
      }
      case ActionTypes.SET_ELIGIBILITY: {
        return {
          ...state,
          isEligible: action.payload.data,
        };
      }
      case ActionTypes.SET_LOGIN_VALUES:{
        return{
          ...state,
          ...action.payload
        }
      }
      case ActionTypes.GET_SEP_REASONS:{
        return{
          ...state,
          sepReasonforS:action.payload.data
        }
      }
      case ActionTypes.RAPID_DISENROLLMENT_BYMONTH:{
        return{
          ...state,
          rapidDisenrollmentbymonth:action.payload.data
        }
      }
      case ActionTypes.MBI_DETAILS:{
        return{
          ...state,
          mbiDetails:action.payload.data
        }
      }
        default:
            return state;
              
    }
}